import Alias from './Alias';
import Aria from './Aria';
import AutoFocus from './AutoFocus';
import Declarative from './Declarative';
import DefaultSubmit from './DefaultSubmit';
import Dependency from './Dependency';
import Excluded from './Excluded';
import Framework from './Framework';
import Icon from './Icon';
import Message from './Message';
import Sequence from './Sequence';
import SubmitButton from './SubmitButton';
import Tooltip from './Tooltip';
import Trigger from './Trigger';
export default {
    Alias,
    Aria,
    AutoFocus,
    Declarative,
    DefaultSubmit,
    Dependency,
    Excluded,
    Framework,
    Icon,
    Message,
    Sequence,
    SubmitButton,
    Tooltip,
    Trigger,
};



// WEBPACK FOOTER //
// ./node_modules/formvalidation/dist/es6/plugins/index.js